import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import NewUser from '@/components/NewUser'
import Settings from '@/components/Settings'
import TagHandle from '@/components/Settings-TagHandle'
import Activity from '@/components/Activity'
import Profile from '@/components/Profile'
import Pending from '@/components/admin/Pending'
import StyleGuide from '@/components/admin/StyleGuide'
import Template from '@/components/admin/Template'
import FiftyFifty from '@/components/admin/FiftyFifty'

import Posts from '@/components/post/Posts'
import Post from '@/components/post/Post'
import PostEdit from '@/components/post/PostEdit'
import PostDetails from '@/components/post/PostDetails'
import PostConfirmation from '@/components/post/PostConfirmation'

import Transparency from '@/components/about/Transparency'
import Privacy from '@/components/about/Privacy'
import About from '@/components/about/About'
import Future from '@/components/about/Future'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			redirect: '/posts'
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
    {
			path: '/about',
			name: 'About',
			component: About
		},
    {
			path: '/transparency',
			name: 'Transparency',
			component: Transparency
		},
    {
			path: '/future',
			name: 'Future',
			component: Future
		},
    {
			path: '/privacy',
			name: 'Privacy',
			component: Privacy
		},
    {
			path: '/dashboard',
			name: 'Dashboard',
			component: Dashboard,
        meta: {
          requiresAuth: true
        }
		},
    {
			path: '/newuser',
			name: 'NewUser',
			component: NewUser,
        meta: {
          requiresAuth: true
        }
		},
		{
			path: '/posts',
			name: 'posts',
			component: Posts
		},
    {
			path: '/post',
			name: 'Post',
			component: Post,
        meta: {
          requiresAuth: true
        }
		},
		{
			path: '/postconfirmation/', 
			name: 'PostConfirmation', 
			component: PostConfirmation,
				meta: {
					requiresAuth: true
				}
		},
		{
			path: '/postdetails/:id', 
			name: 'PostDetails', 
			component: PostDetails
		},

		{
			path: '/postedit/:id', 
			name: 'PostEdit', 
			component: PostEdit,
				meta: {
					requiresAuth: true
				}
		},
    {
			path: '/settings',
			name: 'Settings',
			component: Settings,
        meta: {
          requiresAuth: true
        }
		},
    {
			path: '/settings-taghandle',
			name: 'TagHandle',
			component: TagHandle,
        meta: {
          requiresAuth: true
        }
		},
		{
			path: '/activity',
			name: 'activity',
			component: Activity,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/profile/:id', 
			component: Profile
		},

		{
			path: '/pending',
			name: 'pending',
			component: Pending,
			meta: {
				requiresAuth: true
			}
		},

		{
			path: '/styleguide',
			name: 'styleguide',
			component: StyleGuide,
			meta: {
				requiresAuth: true
			}
		},

		{
			path: '/template',
			name: 'template',
			component: Template,
			meta: {
				requiresAuth: true
			}
		},

		{
			path: '/fiftyfifty',
			name: 'fiftyfifty',
			component: FiftyFifty,
			meta: {
				requiresAuth: true
			}
		},
	]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

export default router